export const SN_STOCK = 'stock'
export const STOCK_ITEMS_UPDATED = SN_STOCK + '/ITEMS_UPDATED'
export const STOCK_SHOPIFY_SHOPS_UPDATED = SN_STOCK + '/SHOPIFY_SHOPS_UPDATED'
export const STOCK_JOBS_UPDATED = SN_STOCK + '/JOBS_UPDATED'
